import React, { useEffect, useState } from "react";
import {
  bannerFor,
  fetchEntitlement,
  installSubscriptionWatcher,
  PRICING_URL,
  SUBSCRIPTION_EVENT,
} from "./entitlement";

/**
 * 이용 기간 띠(2026-10-04) — 남은 기간 7일 이하이거나 끝났을 때만 헤더 아래 한 줄로 보인다.
 * 기능이 402 로 막히면(어느 화면이든) 같은 띠가 '끝났습니다'로 바뀐다. 색은 회색·파랑만.
 */
export default function SubscriptionBanner() {
  const [ent, setEnt] = useState(null);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    installSubscriptionWatcher();
    let alive = true;
    fetchEntitlement().then((e) => alive && setEnt(e));
    const onBlocked = (ev) => {
      setHidden(false);
      setEnt((prev) => ({ ...(prev || {}), ...(ev.detail || {}), allowed: false }));
    };
    window.addEventListener(SUBSCRIPTION_EVENT, onBlocked);
    return () => {
      alive = false;
      window.removeEventListener(SUBSCRIPTION_EVENT, onBlocked);
    };
  }, []);

  const b = bannerFor(ent);
  if (!b || hidden) return null;

  const goPricing = (e) => {
    e.preventDefault();
    window.history.pushState({}, "", PRICING_URL);
    window.dispatchEvent(new PopStateEvent("popstate"));
  };

  return (
    <div
      role="status"
      data-testid="subscription-banner"
      data-kind={b.kind}
      style={{
        display: "flex",
        alignItems: "center",
        gap: 12,
        padding: "8px 16px",
        fontSize: 13,
        lineHeight: 1.5,
        background: b.kind === "expired" ? "#f1f3f5" : "#f8f9fa",
        borderBottom: "1px solid var(--audit-border, #e5e7eb)",
        color: "#374151",
        flexShrink: 0,
      }}
    >
      <span style={{ flex: 1, minWidth: 0 }}>{b.text}</span>
      <a
        href={PRICING_URL}
        onClick={goPricing}
        style={{
          padding: "4px 12px",
          borderRadius: 6,
          background: "#2563eb",
          color: "#fff",
          fontWeight: 600,
          whiteSpace: "nowrap",
          textDecoration: "none",
        }}
      >
        구독하기
      </a>
      {b.kind === "soon" && (
        <button
          type="button"
          aria-label="띠 닫기"
          onClick={() => setHidden(true)}
          style={{ background: "none", border: 0, color: "#6b7280", cursor: "pointer", fontSize: 16 }}
        >
          ×
        </button>
      )}
    </div>
  );
}
